import { DataForm, RecordsAction } from './types'

export const recordsReducer = (
  state: { [formId: string]: DataForm },
  action: RecordsAction,
): { [formId: string]: DataForm } => {
  switch (action.type) {
    case 'initializer':
      return {
        ...state,
        ...action.payload,
      }

    case 'saveRecord':
      return {
        ...state,
        [action.payload.formId!]: action.payload,
      }

    case 'deleteRecords':
      const newState: { [formId: string]: DataForm } = Object.fromEntries(
        Object.values(state)
          .filter((item) => !action.payload.includes(item.formId!))
          .map((item) => [[item.formId], item]),
      )
      return newState

    case 'changeStates':
      const newStates: { [formId: string]: DataForm } = Object.fromEntries(
        Object.values(state).map((currentItem) => {
          const itemChange = action.payload.find((item) => item.id === currentItem.formId)

          return [
            [currentItem.formId],
            {
              ...currentItem,
              ...(itemChange ? { stateForm: itemChange.stateForm } : {}),
            },
          ]
        }),
      )

      return newStates

    default:
      return state
  }
}
